import React, {FC} from "react"

import {Card} from "@irati/ui/src/Layout"
import {IconTypes} from "@irati/ui/src/Button"
import FormattedMessage from "@irati/utils/lang"
import Button from "@irati/ui/src/Button/Button"
import Icon from "@irati/ui/src/Icon"
import makePDF from "@irati/utils/pdf/makePDF"
import {H4} from "@irati/ui/src/Typography"
import {useOrderDocuments} from "@irati/payrollpay/hooks"

interface Props {
  order_id: string
}

const Documents: FC<Props> = ({order_id}) => {
  const {data} = useOrderDocuments({order_id})

  const handleDownloadReport = (fileName: string) => {
    makePDF("", fileName)
  }
  return (
    <Card padding={[2, 2]} marginTop={2} marginLeft={2}>
      <H4 marginBottom={2}>
        <FormattedMessage id="admin.components.orderManagement.documents.title" />
      </H4>
      <Button tertiary onClick={() => handleDownloadReport(data?.documents.hire_agreement)} marginTop={2}>
        <Icon icon={IconTypes.downloadReport} marginRight />
        <FormattedMessage id="admin.components.orderManagement.documents.btn" />
      </Button>
      {data?.documents?.line_manager_approval && (
        <Button tertiary onClick={() => handleDownloadReport(data?.documents?.line_manager_approval)}>
          <Icon icon={IconTypes.downloadReport} marginRight />
          <FormattedMessage id="admin.components.orderManagement.documents.lineManager" />
        </Button>
      )}
    </Card>
  )
}

export default Documents
